import cx from 'classnames'
import { Link } from 'react-router'
import DocumentTitle from 'react-document-title'
import { Icon, NavigationHeader, P } from '@driftt/tide-core-legacy'

import styles from './style.styl'
import 'styles/components/settings/Settings.styl'

const REVOKED_TOKEN_HELP_LINK = 'https://help.drift.com/settings/why-calendars-disconnect'

const PAGE_TITLE = 'My Meetings'

const PAGE_DESCRIPTION = (
  <span>
    Take the back and forth out of scheduling and give leads and customers a direct line to your calendar. Let people schedule meetings with you right from chat or email.{' '}
    <a
      href="https://help.drift.com/article/calendarsetup/"
      title="Drift Calendars help doc"
      target="_blank"
    >
      Learn More
    </a>
  </span>
)

export const Header = ({ nav, title, description, withBorder = true }) => (
  <div className={cx('header setting-page-title', { ['with-border']: withBorder })}>
    {!!nav && (
      <Link className="settings-nav" to={nav.link}>
        <Icon className="settings-nav-back-bracket" width={6} name="arrow-1-left" />
        <div>{nav.label}</div>
      </Link>
    )}
    {!!title && (
      <div className="flex-space-between">
        <h1 className="page-title">{title}</h1>
      </div>
    )}
    {!!description && (
      <div>
        <p className="page-description">{description}</p>
      </div>
    )}
  </div>
)

const CalendarSettingsPage = ({ isTokenRevoked, hideHeader, showHeaderBorder = true, children }) => (
  <DocumentTitle title="My Meetings">
    <div className={styles.CalendarSettings}>
      <div className="calendar-upgrade-pill-wrapper">
        {!hideHeader && (
          <div className="meetings-settings-page-title">
            <NavigationHeader title={PAGE_TITLE}>
              <P className="page-description">
                {PAGE_DESCRIPTION}
              </P>
            </NavigationHeader>
          </div>
        )}
        { isTokenRevoked && (
          <div className="calendar-token-revoked-message">
            <Icon size="30" className="token-revoked-icon" name="warning-triangle" />
            <div>
              <div className="token-revoked-title">
                The calendar connection has been expired or revoked by your calendar provider.
              </div>
              <div>
                Reconnect below to reactivate your calendar features.{' '}
                <a href={REVOKED_TOKEN_HELP_LINK} target="_blank">
                  Learn More
                </a>.
              </div>
            </div>
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  </DocumentTitle>
)

export default CalendarSettingsPage



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/page.js